import { formatDate, CreateFechaMoment, formatDateTime, CreateFechaHoraMoment } from "../../../utils/fecha";
import { toDecimalString } from "../../../utils/numbers";
import { BooleanCellRenderer } from "../../CustomCells/BooleanCellRenderer";
import SubirBajarCellRenderer from "../../CustomCells/SubirBajarCellRenderer";
import MostrarOcultarCellRenderer from "../../CustomCells/MostrarOcultarCellRenderer";
import OtroFormatoCellRenderer from "../../CustomCells/OtroFormatoCellRenderer";
import LabelBottomCellRenderer from "../../CustomCells/LabelBottomCellRenderer";

export const formatNumber = (params) => {

  if (params.value === null || params.value === undefined || params.value.length === 0) {
    return "";
  }

  if (typeof params.value === "string") {
    return toDecimalString(parseFloat(params.value));
  } else {
    return toDecimalString(params.value);
  }
};

export const formatInt = (params) => {
  return params.value !== null && params.value !== undefined ? parseInt(params.value) : "";
};

export const formatDateStr = (params) => {
  return params.value !== null && params.value !== undefined && params.value.length > 0
    ? formatDate(CreateFechaMoment(params.value))
    : "";
};

export const formatDateTimeStr = (params) => {
  return params.value !== null && params.value !== undefined && params.value.length > 0
    ? formatDateTime(CreateFechaHoraMoment(params.value))
    : "";
};

export const formatText = (params) => {
  return params.value === null ? "" : params.value;
};

export const formatBoolToInt = (params) => {
  return params.value === true || params.value === 1 ? 1 : 0;
};

export const formatBoolToText = (params) => {
  return params.value === true || params.value === 1 ? "Si" : "No";
};

export const numberParser = (params) =>{
  return Number(params.newValue);
}

export const getComparatorDate = (filterLocalDateAtMidnight, cellValue) => {
  var dateAsString = formatDate(cellValue);
  if (dateAsString == null) return 0;

  let dateParts = dateAsString.split("/");
  let day = Number(dateParts[0]);
  let month = Number(dateParts[1]) - 1;
  let year = Number(dateParts[2]);
  let cellDate = new Date(year, month, day);

  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
  } else if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  } else {
    return 0;
  }
};

export const hasTotalColumns = (columnDefs) => columnDefs.some((c) => c.ipkTotalizar);
export const getTotalColumnsDefs = (columnDefs) => columnDefs.filter((c) => c.ipkTotalizar);
export const extractPinnedBottomDataSchema = (columnDefs) => {
  return getTotalColumnsDefs(columnDefs).reduce((p, c) => {
    p[c.field] = c.ipkDefaultValue;
    return p;
  }, {});
};

const filterOptions = [
  'empty',
  {
      displayKey: 'Sin Fecha',
      displayName: 'Sin Fecha',
      test: function (filterValue, cellValue) {
          return cellValue === null;
      },
      hideFilterInput: true,
  },
  'equals',
  'notEqual',
  'lessThan',
  'lessThanOrEqual',
  'greaterThan',
  'greaterThanOrEqual',
  'inRange'
];

const TEXT_COLUMN = {
  editable: false,
  sortable: true,
  type: "",
  hide: false,
  filter: "agTextColumnFilter",
  suppressMenu: true,
  valueFormatter: formatText,
  ipkDefaultValue: String(),
  ipkTotalizar: false,
};
const NUMERIC_COLUMN = {
  editable: false,
  sortable: true,
  valueFormatter: formatInt,
  type: "numericColumn",
  hide: false,
  filter: "agNumberColumnFilter",
  suppressMenu: true,
  ipkDefaultValue: Number(),
  ipkTotalizar: false,
  valueParser: numberParser
};
const DECIMAL_COLUMN = {
  editable: false,
  sortable: true,
  valueFormatter:formatNumber,
  type: "numericColumn",
  hide: false,
  filter: "agNumberColumnFilter",
  suppressMenu: true,
  ipkDefaultValue: Number(),
  ipkTotalizar: true,
  valueParser: numberParser
};

const DATE_COLUMN = {
  valueFormatter: formatDateStr,
  sortable: true,
  cellStyle: { textAlign: "left" },
  editable: false,
  filter: "agDateColumnFilter",
  type: "dateColumn",
  suppressMenu: true,
  filterParams: { resetButton: true, filterOptions: filterOptions, comparator: getComparatorDate },
  ipkDefaultValue: String(),
  ipkTotalizar: false,
};

const DATETIME_COLUMN = {
  valueFormatter: formatDateTimeStr,
  sortable: true,
  cellStyle: { textAlign: "left" },
  editable: false,
  filter: "agDateColumnFilter",
  type: "dateColumn",
  suppressMenu: true,
  filterParams: { resetButton: true, filterOptions: filterOptions, comparator: getComparatorDate },
  ipkDefaultValue: String(),
  ipkTotalizar: false,
};

const BOOLEAN_COLUMN = {
  editable: false,
  sortable: true,
  valueFormatter: formatBoolToText,
  type: "",
  hide: false,
  filter: "agTextColumnFilter",
  suppressMenu: true,
  ipkTotalizar: false,
  cellStyle: { "text-align": "center" },
  cellRendererFramework: BooleanCellRenderer,
  floatingFilterComponent: 'SiNoFilter',
  floatingFilterComponentParams: {
    suppressFilterButton: true
}
};

const POPOVER_COLUMN = {
  editable: false,
  sortable: false,
  valueFormatter: "",
  type: "",
  hide: false,
  suppressMenu: true,
  ipkTotalizar: false,
  cellStyle: { "text-align": "center" }
}

const MOSTRAR_OCULTAR_COLUMN = {
  editable: false,
  sortable: true,
  valueFormatter: "",
  type: "",
  hide: false,
  suppressMenu: true,
  ipkTotalizar: false,
  cellStyle: { "text-align": "center" },
  cellRendererFramework: MostrarOcultarCellRenderer,  
  filter: "agTextColumnFilter",
  floatingFilterComponent: 'MostrarOcultarFilter',
  floatingFilterComponentParams: {
    suppressFilterButton: true
}
}
const SUBIR_BAJAR_COLUMN = {
  editable: false,
  sortable: true,
  valueFormatter: "",
  type: "",
  hide: false,
  suppressMenu: true,
  ipkTotalizar: false,
  cellStyle: { "text-align": "center" },
  cellRendererFramework: SubirBajarCellRenderer,  
  filter: "agTextColumnFilter",
  floatingFilterComponent: 'SubirBajarFilter',
  floatingFilterComponentParams: {
    suppressFilterButton: true
}
}

const LABEL_BOTTOM_COLUMN = {
  editable: false,
  sortable: true,
  valueFormatter: "",
  type: "",
  hide: false,
  suppressMenu: true,
  ipkTotalizar: false,
  cellStyle: { "text-align": "center" },
  cellRendererFramework: LabelBottomCellRenderer,  
  filter: "agTextColumnFilter",
  floatingFilterComponent: 'SubirBajarFilter',
  floatingFilterComponentParams: {
    suppressFilterButton: true
}
}

const OTRO_FORMATO_COLUMN = {
  editable: false,
  sortable: true,
  valueFormatter: "",
  type: "",
  hide: false,
  suppressMenu: true,
  ipkTotalizar: false,
  cellStyle: { "text-align": "center" },
  cellRendererFramework: OtroFormatoCellRenderer,  
  filter: "agTextColumnFilter",
  floatingFilterComponent: 'OtroFormatoFilter',
  floatingFilterComponentParams: {
    suppressFilterButton: true
}
}


export const ColumnsFactory = {
  TextColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...TEXT_COLUMN, headerName: headerName, field: field }
      : { ...TEXT_COLUMN, headerName: headerName, field: field, ...extra };
  },
  NumericColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...NUMERIC_COLUMN, headerName: headerName, field: field }
      : { ...NUMERIC_COLUMN, headerName: headerName, field: field, ...extra };
  },
  DecimalColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...DECIMAL_COLUMN, headerName: headerName, field: field }
      : { ...DECIMAL_COLUMN, headerName: headerName, field: field, ...extra };
  },
  DateColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...DATE_COLUMN, headerName: headerName, field: field }
      : { ...DATE_COLUMN, headerName: headerName, field: field, ...extra };
  },
  BooleanColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...BOOLEAN_COLUMN, headerName: headerName, field: field }
      : { ...BOOLEAN_COLUMN, headerName: headerName, field: field, ...extra };
  },
  PopoverColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...POPOVER_COLUMN, headerName: headerName, field: field }
      : { ...POPOVER_COLUMN, headerName: headerName, field: field, ...extra };
  },
  DateTimeColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...DATETIME_COLUMN, headerName: headerName, field: field }
      : { ...DATETIME_COLUMN, headerName: headerName, field: field, ...extra };
  },
  MostrarOcultarColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...MOSTRAR_OCULTAR_COLUMN, headerName: headerName, field: field }
      : { ...MOSTRAR_OCULTAR_COLUMN, headerName: headerName, field: field, ...extra };
  },
  SubirBajarColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...SUBIR_BAJAR_COLUMN, headerName: headerName, field: field }
      : { ...SUBIR_BAJAR_COLUMN, headerName: headerName, field: field, ...extra };
  },
  OtroFormatoColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...OTRO_FORMATO_COLUMN, headerName: headerName, field: field }
      : { ...OTRO_FORMATO_COLUMN, headerName: headerName, field: field, ...extra };
  },
  LabelBottomColumn: (headerName, field, extra) => {
    return extra === undefined
      ? { ...LABEL_BOTTOM_COLUMN, headerName: headerName, field: field }
      : { ...LABEL_BOTTOM_COLUMN, headerName: headerName, field: field, ...extra };
  }

};
